import '@root/pages/workloload-scanning/sideoverlay.scss';
import { useState } from 'react';

import workload12 from '@assets/svg/icons/workload2.svg';
import { Box } from '@mui/material';
// import CountTooltip from '@root/components/table/cell-types/CountTooltip';
import DateFormatPipe from '@root/components/utilities/DateFormatPipe';
import CircularCloseButton from '@root/components/v2/ui-elements/CircularCloseButton';
import CisaKevAlert from '@root/pages/workloload-scanning/CisaKevAlert';
import DescriptionToggle from '@root/pages/workloload-scanning/DescriptionToggle';
// import { DEFAULT_PAGE_SIZE } from '@components/table/table';
import agent from '@root/agent';
// import Button from '@mui/material/Button';

import { SeverityWithText } from '@root/components/bootstrapTable/badges/severity';
// import ViperButton from './ViperButton';
import LinkToggle from '@root/pages/workloload-scanning/LinkToggle';
// import LinkToggle from './LinkToggle';
import { useQuery as useQueryReact } from '@tanstack/react-query';

import { capitalizeFirstLetter } from '@root/utilities/string';
import FixedInVersion from '@root/pages/workloload-scanning/FixedInVersion';

import Loader from '@root/components/common/Loader';
import CountTooltip from '@root/components/Tooltip/CountTooltip';
import isEmpty from 'lodash/isEmpty';
import SideOverlayTabMenu, { SideOverlayBody } from '@root/components/v2/SideOverlayTabMenu';
import { HOST_CVE_MENU_CATEGORIES } from './tabMenu';

const DetailsPanel = props => {
  // let disableRemoveTagsButton = false;
  const { selectedRow, onClose } = props;
  const [currentSubTab, setCurrentSubTab] = useState('Details');

  const { data: vulnerabilityDetails, isFetching: isFetchingVulnerabilityDetails } = useQueryReact(
    ['get_vulnerability_details', selectedRow],
    () =>
      agent.Vulnerabilites.get_vulnerability_details({
        cve_id: selectedRow?.cve_id,
      }),
    {
      enabled: Boolean(selectedRow?.cve_id),
    },
  );

  //   console.log(isFetchingVulnerabilityDetails);

  const formatVlue = v => {
    if (typeof v === 'string' && v?.includes('Updating')) return '-';
    else return v;
  };

  return (
    <div className="sidebarOpen2">
      <div className={`Resources__Backdrop2`} />
      <div className="Resources__DataSidebar2 Resources__DataSidebar2--stackedMenu width-small-sideoverlay">
        <div className="Resources__SidebarHeader">
          <div style={{ display: 'flex', paddingTop: '12px', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
              <div style={{ display: 'flex' }}>
                <img src={workload12} />
                <span
                  className="text font-16 weight-700"
                  style={{
                    marginLeft: '10px',
                    color: 'var(--secondary-500)',
                    lineHeight: 1,
                  }}>
                  {selectedRow?.cve_id}
                </span>
                {/* <Box flex={1} width={'1100px'} /> */}
              </div>
              <span
                style={{
                  marginLeft: '40px',
                  marginTop: '-12px',
                  // color: 'var(--secondary-400)',
                  fontSize: '12px',
                  fontWeight: 500,
                }}>
                Common Vulnerability and Exposures
              </span>
            </div>
            <Box display={'flex'} alignItems={'center'} gap={'10px'}>
              <CircularCloseButton onClick={() => onClose()} />
            </Box>
          </div>

          <div
            className="text font-16 weight-600"
            style={{
              color: 'var(--secondary-600)',
              paddingLeft: '10px',
            }}>
            {selectedRow?.service}
          </div>
        </div>

        <div className="Resources__SidebarContent CustomScrollbar">
          <SideOverlayBody
            menu={
              <SideOverlayTabMenu
                categories={HOST_CVE_MENU_CATEGORIES}
                activeTab={currentSubTab}
                onChange={setCurrentSubTab}
                ariaLabel="Vulnerability details sections"
              />
            }>
            <div className="Resources__SidebarTabContent CustomScrollbar">
              {isFetchingVulnerabilityDetails ? (
                <Loader />
              ) : (
                <div style={{ padding: '0px 6px' }}>
                  <DescriptionToggle text={selectedRow?.description ?? '-'} />

                  <div style={{ padding: '20px', overflow: 'auto' }} className="workload CustomScrollbar">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: '1', padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Packages Name
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{
                            marginTop: '5px',
                            color: 'var(--gray-900) !important',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1px',
                            lineHeight: '19.12px',
                          }}>
                          <span className="text value">
                            {' '}
                            {!selectedRow?.package_name || isEmpty(selectedRow?.package_name)
                              ? '-'
                              : selectedRow?.package_name}
                          </span>
                        </div>
                      </div>
                      <div style={{ flex: '1', padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Packages Type
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{
                            marginTop: '5px',
                            color: 'var(--gray-900) !important',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1px',
                            lineHeight: '19.12px',
                          }}>
                          <span className="text value">
                            {' '}
                            {!selectedRow?.package_type || isEmpty(selectedRow?.package_type)
                              ? '-'
                              : selectedRow?.package_type}
                          </span>
                        </div>
                      </div>
                      <div style={{ flex: '1', padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Packages Version
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{
                            marginTop: '5px',
                            color: 'var(--gray-900) !important',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1px',
                            lineHeight: '19.12px',
                          }}>
                          <span className="text value">
                            {!selectedRow?.package_version || isEmpty(selectedRow?.package_version)
                              ? '-'
                              : selectedRow?.package_version}
                          </span>
                        </div>
                      </div>
                      <div style={{ flex: '1', padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Packages Language
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{
                            marginTop: '5px',
                            color: 'var(--gray-900) !important',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1px',
                            lineHeight: '19.12px',
                          }}>
                          <span className="text value">
                            {!selectedRow?.package_language || isEmpty(selectedRow?.package_language)
                              ? '-'
                              : selectedRow?.package_language}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: '1', padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Published Date:
                        </div>
                        <div
                          className="text font-14"
                          style={{
                            marginTop: '5px',
                            color: 'var(--gray-900) !important',
                            lineHeight: '19.12px',
                            fontWeight: '500 !important',
                          }}>
                          {selectedRow?.discovered_at ? DateFormatPipe(selectedRow?.discovered_at) : '-'}
                        </div>
                      </div>
                      <div style={{ flex: '1', padding: '0 10px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Source:
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.source ??
                            vulnerabilityDetails?.data?.cvssMetricV31?.source ??
                            selectedRow?.elastic_data?.source ??
                            '-'}
                        </div>
                      </div>
                      <div style={{ flex: '1', padding: '0 10px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Known Exploit:
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.cve_risk?.exploit === false ||
                          vulnerabilityDetails?.data?.cve_risk?.exploit === false
                            ? 'False'
                            : 'Yes'}
                        </div>
                      </div>
                      <div style={{ flex: '1', padding: '0 10px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          EPSS:
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {(
                            selectedRow?.details?.cve_details?.epss?.epss_percentile ??
                            vulnerabilityDetails?.data?.cvssMetricV31?.epss_percentile ??
                            selectedRow?.elastic_data?.epss ??
                            0
                          )?.toFixed?.(2)}
                          %
                        </div>
                        {/* <div style={{ marginTop: '5px' }}>0.85</div> */}
                      </div>
                    </div>
                    <div style={{ flex: '1' }}>
                      <div
                        className="text font-14"
                        style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                        CISA KEV
                      </div>

                      <div
                        className="text font-14 weight-500"
                        style={{
                          marginTop: '5px',
                          color: 'var(--gray-900) !important',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '1px',
                          lineHeight: '19.12px',
                        }}>
                        {selectedRow?.details?.cisa_data ? (
                          <CisaKevAlert data={selectedRow?.details?.cisa_data} />
                        ) : vulnerabilityDetails?.data?.cvssMetricV31?.cisa_data ? (
                          <CisaKevAlert data={vulnerabilityDetails?.data?.cvssMetricV31?.cisa_data} />
                        ) : (
                          <span className="text value" style={{ marginBottom: '20px' }}>
                            -
                          </span>
                        )}
                      </div>
                    </div>
                    <div style={{ flex: '1' }}>
                      <div
                        className="text font-14"
                        style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                        Fixed In Versions
                      </div>

                      <div
                        className="text font-14 weight-500"
                        style={{
                          marginTop: '5px',
                          color: 'var(--gray-900) !important',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '1px',
                          lineHeight: '19.12px',
                        }}>
                        {selectedRow?.fix_version ? (
                          <FixedInVersion data={selectedRow?.fix_version ?? '-'} />
                        ) : (
                          <span className="text value" style={{ marginBottom: '20px' }}>
                            -
                          </span>
                        )}
                      </div>
                    </div>
                    <span
                      className="text font-14"
                      style={{
                        position: 'relative',
                        bottom: '7px',
                        left: '2px',
                        fontWeight: 600,
                        lineHeight: '19.12px',
                      }}>
                      CVSS(3.1)
                    </span>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Base Score
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--secondary-400) !important' }}>
                          <span
                            style={{
                              backgroundColor: '#5AB3FF',
                              borderRadius: '50%',
                              width: '35px',
                              height: '35px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              fontSize: '12px',
                              fontFamily: 'Manrope',
                              fontWeight: 600,
                              // border: '1px solid #CBD5E0',
                            }}>
                            {selectedRow?.cvss_score === 0
                              ? 0
                              : parseInt(selectedRow?.cvss_score) === 10
                                ? 10
                                : vulnerabilityDetails?.data?.cvssMetricV31?.cvssMetricV31?.find(
                                    item => item.cvssData.version === '3.1' || item.cvssData.version === '3.0',
                                  )?.cvssData?.baseScore ||
                                  parseFloat(selectedRow?.cvss_score)?.toFixed(1) ||
                                  selectedRow?.elastic_data?.cvss?.[0]?.metrics?.baseScore?.toFixed(1) ||
                                  '-'}
                          </span>
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Impact Score
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--secondary-400) !important' }}>
                          {vulnerabilityDetails?.data?.cvssMetricV31?.cvssMetricV31?.[0] ? (
                            <span
                              style={{
                                backgroundColor: '#5AB3FF',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                // border: '1px solid #CBD5E0',
                              }}>
                              {vulnerabilityDetails?.data?.cvssMetricV31?.cvssMetricV31?.[0]?.impactScore != null
                                ? parseFloat(
                                    vulnerabilityDetails?.data?.cvssMetricV31?.cvssMetricV31?.[0]?.impactScore,
                                  ).toFixed(1)
                                : selectedRow?.elastic_data?.cvss?.[0]?.metrics?.impactScore?.toFixed(1) || '-'}
                            </span>
                          ) : selectedRow?.elastic_data?.cvss?.[0]?.metrics?.impactScore ? (
                            <span
                              style={{
                                backgroundColor: '#5AB3FF',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                // border: '1px solid #CBD5E0',
                              }}>
                              {selectedRow?.elastic_data?.cvss?.[0]?.metrics?.impactScore?.toFixed(1)}
                            </span>
                          ) : (
                            '-'
                          )}
                        </div>
                      </div>

                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          EPSS Score
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--secondary-400) !important' }}>
                          {selectedRow?.threat_trend?.epss != null ? (
                            <span
                              style={{
                                backgroundColor: '#5AB3FF',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                // border: '1px solid #CBD5E0',
                              }}>
                              {parseFloat(selectedRow?.threat_trend?.epss).toFixed(1)}
                            </span>
                          ) : selectedRow?.elastic_data?.epss != null ? (
                            <span
                              style={{
                                backgroundColor: '#5AB3FF',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                // border: '1px solid #CBD5E0',
                              }}>
                              {parseFloat(selectedRow?.elastic_data?.epss).toFixed(1)}
                            </span>
                          ) : (
                            '-'
                          )}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Exploitability Score
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--secondary-400) !important' }}>
                          {vulnerabilityDetails?.data?.cvssMetricV31?.cvssMetricV31?.[0]?.exploitabilityScore !=
                          null ? (
                            <span
                              style={{
                                backgroundColor: '#5AB3FF',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                // border: '1px solid #CBD5E0',
                              }}>
                              {parseFloat(
                                vulnerabilityDetails?.data?.cvssMetricV31?.cvssMetricV31?.[0]?.exploitabilityScore,
                              ).toFixed(1)}
                            </span>
                          ) : selectedRow?.elastic_data?.cvss?.[0]?.metrics?.exploitabilityScore != null ? (
                            <span
                              style={{
                                backgroundColor: '#5AB3FF',
                                borderRadius: '50%',
                                width: '35px',
                                height: '35px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '12px',
                                fontFamily: 'Manrope',
                                fontWeight: 600,
                                // border: '1px solid #CBD5E0',
                              }}>
                              {parseFloat(selectedRow?.elastic_data?.cvss?.[0]?.metrics?.exploitabilityScore)?.toFixed(
                                1,
                              )}
                            </span>
                          ) : (
                            '-'
                          )}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Severity
                        </div>
                        <div style={{ marginTop: '5px' }}>
                          <SeverityWithText propsValue={selectedRow?.severity} />
                        </div>
                        {/* <div style={{ marginTop: '5px' }}>-</div> */}
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Privileges Required
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.privilegesRequired
                            ? selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.privilegesRequired
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : '-'}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Confidentiality
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.confidentialityImpact
                            ? selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.confidentialityImpact
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Attack Vector
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.elastic_data?.attack_vector
                            ? selectedRow?.elastic_data?.attack_vector
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : selectedRow?.details?.attack_vector
                              ? selectedRow?.details?.attack_vector
                                  .toLowerCase()
                                  .replace(/^./, char => char.toUpperCase())
                              : '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          User Interaction
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.userInteraction
                            ? selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.userInteraction
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : '-'}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Attack Complexity
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.attackComplexity
                            ? selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.attackComplexity
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Scope
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.scope
                            ? selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.scope
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Availability
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.availabilityImpact
                            ? selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.availabilityImpact
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : '-'}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Hackerone Count
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {formatVlue(vulnerabilityDetails?.data?.threat_trend_data?.hackerone_count ?? '-')}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Hackerone Rank
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {formatVlue(vulnerabilityDetails?.data?.threat_trend_data?.hackerone_rank ?? '-')}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Is POC
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {JSON.stringify(vulnerabilityDetails?.data?.threat_trend_data?.is_poc) ?? '-'}
                        </div>
                      </div>
                    </div>{' '}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Is OSS
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {JSON.stringify(vulnerabilityDetails?.data?.threat_trend_data?.is_oss) ?? '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Is Remote
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {JSON.stringify(vulnerabilityDetails?.data?.threat_trend_data?.is_remote) ?? '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Is Template
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {JSON.stringify(vulnerabilityDetails?.data?.threat_trend_data?.is_template) ?? '-'}
                        </div>
                      </div>
                    </div>{' '}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Last Modified
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {vulnerabilityDetails?.data?.threat_trend_data?.last_modified &&
                          !vulnerabilityDetails?.data?.threat_trend_data?.last_modified?.includes('Updating')
                            ? DateFormatPipe(vulnerabilityDetails?.data?.threat_trend_data?.last_modified)
                            : selectedRow?.elastic_data?.last_seen
                              ? DateFormatPipe(selectedRow?.elastic_data?.last_seen)
                              : '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Weakness
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {vulnerabilityDetails?.data?.threat_trend_data?.weaknesses_type?.[0] ?? '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          First Seen
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.first_seen ? DateFormatPipe(selectedRow?.first_seen) : '-'}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Authentication
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.confidentialityImpact
                            ? selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.confidentialityImpact
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : '-'}
                        </div>
                      </div>

                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Last Updated
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.threat_trend_data?.last_modified &&
                          !selectedRow?.threat_trend_data?.last_modified?.includes('Updating')
                            ? DateFormatPipe(selectedRow?.threat_trend_data?.last_modified)
                            : '-'}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          OWASP Top 10
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.details?.['OWASP Top 10'] === false ? 'False' : 'True'}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          URL
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {selectedRow?.urls && selectedRow.urls.length > 0 ? (
                            <CountTooltip labels={selectedRow?.urls} />
                          ) : (
                            '-'
                          )}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Vendor Advisory
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {vulnerabilityDetails?.data?.threat_trend_data?.vendor_advisory &&
                          !vulnerabilityDetails?.data?.threat_trend_data?.vendor_advisory?.includes('Updating') ? (
                            <LinkToggle links={vulnerabilityDetails?.data?.threat_trend_data?.vendor_advisory} />
                          ) : (
                            '-'
                          )}
                        </div>
                      </div>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          SANS Top 25
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {vulnerabilityDetails?.data?.details?.['SANS Top 25'] === false ? 'False' : 'True'}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        textAlign: 'left',
                        marginBottom: '20px',
                      }}>
                      <div style={{ flex: 1, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Vulnerability Status
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {capitalizeFirstLetter(
                            formatVlue(
                              selectedRow?.threat_trend_data?.vuln_status ??
                                vulnerabilityDetails?.data?.threat_trend_data?.vuln_status,
                            ) ?? '-',
                          )}
                        </div>
                      </div>
                      <div style={{ flex: 2, padding: '0 5px' }}>
                        <div
                          className="text font-14"
                          style={{ color: 'var(--secondary-300) !important', fontWeight: 600 }}>
                          Authentication
                        </div>
                        <div
                          className="text font-14 weight-500"
                          style={{ marginTop: '5px', color: 'var(--gray-900) !important', lineHeight: '19.12px' }}>
                          {vulnerabilityDetails?.data?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData
                            ?.confidentialityImpact
                            ? selectedRow?.details?.cvssMetricV31?.cvssMetricV31?.[0]?.cvssData?.confidentialityImpact
                                .toLowerCase()
                                .replace(/^./, char => char.toUpperCase())
                            : '-'}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </SideOverlayBody>
        </div>
      </div>
    </div>
  );
};
export default DetailsPanel;
